__turbopack_context__.v({
  "active": "ColorsSection-module__Fa5q6G__active",
  "backgroundColor": "ColorsSection-module__Fa5q6G__backgroundColor",
  "line": "ColorsSection-module__Fa5q6G__line",
  "root": "ColorsSection-module__Fa5q6G__root",
});
